import '../../utils/a11yAccordion.js';
import '../../utils/clickMenu.js';

/** Remove pointer events to assist with FPS **/
var cover = document.createElement('div'),
  timer;

cover.setAttribute('class', 'scroll-cover');

window.addEventListener(
  'scroll',
  function () {
    clearTimeout(timer);
    document.body.appendChild(cover);

    timer = setTimeout(function () {
      document.body.removeChild(cover);
    }, 300);
  },
  false
);

$('.main-nav').clickMenu({ expanders: true });
$('.nav-rail').clickMenu({ menutype: 'accordion', expanders: true, isAutoClose: false });
$('.navigation-pills').clickMenu();


/* Nick Goodrum's FAUX SELECT Modified by: Fernando Pe�a
   ================================================================ */

$('.faux-select').each(function () {
  var $selectWrap = $(this),
    $expander = $selectWrap.children('a'),
    $expandable = $expander.siblings('ul'),
    $expandableChildren = $expandable.children();
  if ($expandableChildren.length <= 0) {
    $selectWrap.hide();
  }
  $expander.on('click', function (e) {
    e.preventDefault();

    if ($selectWrap.hasClass('opened')) {
      $('body').off('click', fauxSelectHandler);
      $expandable.off('keydown', keyboardSelect);
      $expandable.slideUp(function () {
        $selectWrap.removeClass('opened');
      });
    } else {
      $('.faux-select.opened').children('a').trigger('click');

      $selectWrap.addClass('opened');
      $expandable.slideDown(function () {
        $expandable.find('a').attr('tabIndex', -1);
        $expandable.find('li:first-child a').attr('tabIndex', 0).focus();

        $expandable.on('keydown', keyboardSelect);
      });
      $('body').on('click', fauxSelectHandler);
    }

    $expandableChildren.on('click', function (e) {
      e.preventDefault();
      $expandableChildren.removeClass('selected');
      $(this).addClass('selected');
      $expander.find('.value').text($(this).text());

      $('body').off('click', fauxSelectHandler);

      $expandable.off('keydown', keyboardSelect);

      $expandable.slideUp(function () {
        $selectWrap.removeClass('opened');
      });
    });
  });

  function keyboardSelect(event) {
    if (event.keyCode !== 27 && event.keyCode !== 9) {
      var $currItem = $(document.activeElement).parent(),
        idx = $currItem.index(),
        $anchor;

      $(event.target).attr('tabIndex', -1);

      // decide what do do based on the keyCode
      event.preventDefault();

      switch (event.keyCode) {
        // move to previous item
        case 37: // left
        case 38: // up
          if ($currItem.prev().length >= 0) {
            $anchor = $expandable.find('li:eq(' + (idx - 1) + ') a');
          } else {
            $anchor = $expandable.find('li:last-child a');
          }
          break;
        // move to next item
        case 39: // right
        case 40: // down
          if ($currItem.next().length >= 0) {
            $anchor = $expandable.find('li:eq(' + (idx + 1) + ') a');
          } else {
            $anchor = $expandable.find('li:first-child a');
          }
          break;
        // go to the beginning of the list
        case 33: // page up
        case 36: // home
          $anchor = $expandable.find('li:first-child a');
          break;
        // go to the end of the list
        case 34: // page down
        case 35: // end
          $anchor = $expandable.find('li:last-child a');
          break;
      }
      if ($anchor) {
        $currItem.attr('tabIndex', -1);
        $anchor.attr('tabIndex', 0).focus();
      }
    } else {
      if (event.keyCode === 27) {
        $expander.focus();
      }
      $expander.trigger('click');
    }
  }

  function fauxSelectHandler(e) {
    if ($(e.target).parents('.faux-select').length <= 0 && e.originalEvent) {
      $('.faux-select.opened').children('a').trigger('click');
      $('body').off('click', fauxSelectHandler);
    }
  }
});

$(document).ready(function () {
  var $html = $('html'),
    $body = $('body'),
    $hintedInput = $('.hinted-input');

  /* ================================================================
        UTILITY
    ================================================================ */
  
      $('.accordion-widget').a11yAccordion();
    $('.accordion-widget').show();

  /** HINTED INPUT **/
  var $hintedInput = $('.hinted-input');

  $hintedInput.on('focus', 'input', function (e) {
    $(this).addClass('hint');
  });

  $hintedInput.on('blur', 'input', function (e) {
    var $this = $(this);
    if ($this.val().length <= 0) {
      $(this).removeClass('hint');
    }
  });

  $hintedInput.find('input').each(function () {
    var $this = $(this);
    if ($this.val().length > 0) {
      $this.addClass('hint');
    }
  });

  /* ================================================================
        SITE SPECIFIC FUNCTIONS
    ================================================================ */

  /** Video Module */
  const videoModule = document.querySelector('.video-module');
  if (videoModule) {
    const playVideo = function (e) {
      const button = e.currentTarget;
      const target = button.getAttribute('data-target');
      const iframe = document.querySelector(`iframe[data-id="${target}"]`);
      const type = button.getAttribute('data-type');
      if (type === 'standard') {
        button.classList.add('hidden');
      }
      const thumbnail = iframe.nextElementSibling;
      thumbnail.classList.add('hidden');
      const src = iframe.getAttribute('src');
      const playSrc = iframe.setAttribute('src', src + '?rel=0&autoplay=1');
    };
    const videoItems = videoModule.querySelectorAll('.item');
    for (let i = 0; i < videoItems.length; i++) {
      const item = videoItems[i];
      const play = item.querySelector('.play-button');
      play.addEventListener('click', playVideo);
    }
  }

  /** Site Search **/
  $('.search-toggle').on('click', function (e) {
    var $toggle = $(this),
      $searchControls = $('.site-search .form-group');

    
      e.preventDefault();
      if ($toggle.hasClass('active')) {
        $body.off('click touchstart', searchToggleHandler);
        $searchControls.slideUp(function () {
          $toggle.removeClass('active').focus();
        });
      } else {
        $toggle.addClass('active');
        $body.on('click touchstart', searchToggleHandler);
        $searchControls.slideDown(function () {
          $searchControls.find("input[type='search']").focus();
        });
      }
  });
  function searchToggleHandler(e) {
    if (
      !$('.search-toggle').is(e.target) &&
      !$('.site-search').is(e.target) &&
      $('.site-search').has(e.target).length === 0
    ) {
      $('.search-toggle').trigger('click');
      $body.off('click touchstart', searchToggleHandler);
    }
  }

  /** Main Navigation Functions **/
  $('.header-top').append('<div class="main-nav-wrapper"></div>');

  function mainNavDrawer() {
    var $mainNav = $('.main-nav'),
      $siteSearch = $('.site-search'),
      $mainNavWrapper = $("<div class='main-nav-wrapper'></div>"),
      $menuToggle = $("<button class='menu-toggle'><span><span class='visuallyhidden'>Menu</span></span></button>"),
      $body = $('body');

    if (matchMedia('(min-width:64em)').matches) {
      $mainNav.appendTo($('.header-top .header-column:nth-child(2)'));
      $siteSearch.appendTo($('.header-top .header-column:nth-child(2)'));
    } else {
      $siteSearch.appendTo($('.main-nav-wrapper'));
      $mainNav.appendTo($('.main-nav-wrapper'));
    }

    if ($('#site-header .menu-toggle').length <= 0) {
      $('.header-top .header-column:first-child').append($menuToggle);

      $menuToggle.on('click', function () {
        var $toggle = $(this),
          $mainNavWrapper = $('.main-nav-wrapper');

        if ($toggle.hasClass('active')) {
          $mainNavWrapper.fadeOut('fast', function () {
            $html.removeClass('mobile-menu-active');
            $body.removeClass('mobile-menu-active');
            $toggle.removeClass('active');
          });
        } else {
          $toggle.addClass('active');
          $html.addClass('mobile-menu-active');
          $body.addClass('mobile-menu-active');
          $mainNavWrapper.fadeIn('slow');
        }
      });
    }
  }

  $(document).ready(mainNavDrawer);
  $(window).resize(mainNavDrawer);

  /** SLIDESHOW WITH BACKGROUND IMAGES START **/
  $('.slideshow.has-background-images').each(function () {
    var $this = $(this);

    $this.on('beforeChange', function (e, slick, currSlide, nextSlide) {
      var $nextSlide = $(slick.$slides[nextSlide]);
      $nextSlide.removeClass('static').addClass('loaded');
      $('.slick-cloned.static').removeClass('static').addClass('loaded');
    });
    $this.find('.slick-current.slick-active').removeClass('static').addClass('loaded');
  });
  /** SLIDESHOW WITH BACKGROUND IMAGES END **/

  $('.footer-newsletter select').each(function () {
    $(this).find('option').first().attr('disabled', 'disabled').attr('value', '');
  });

  $('.documents.featured .faux-select').each(function () {
    var $this = $(this),
      $docLinks = $this.find('a'),
      $submit = $this.find("button[type='submit']");

    $docLinks.on('click', function (e) {
      e.preventDefault();
    });

    $submit.on('click', function () {
      window.open($this.find('.selected a').attr('href'), '_blank');
    });
  });

  $('.callout .faux-select ul a').on('click', function () {
    location.assign($(this).attr('href'));
  });

  /* Footer newsletter form */

  //dimiss succes mesagge on click */
  $('.form-submit-success').on('click', function () {
    $(this).hide('slow');
  });

  /** Weglot Flags Only */
  //On canadian affiliates fund page, show the opposite language flag for english/french sites.
  //The french site seems to be forcing french urls so were overwriting it on the english link.
  const locationName = window.location.hostname;
  if (locationName.indexOf('french.seiufunds') > -1) {
    const englishFlag = document.querySelector('.weglot-flag__item.english');
    if (englishFlag) {
      englishFlag.href = 'https://www.seiufunds.org/funds/seiu-canadian-affiliates-fund';
    }
  }
  const flagContainer = document.querySelector('.weglot-flag--container');
  if (flagContainer) {
    const locationName = window.location.hostname;
    if (locationName.indexOf('french.seiufunds') > -1) {
      const frenchFlag = document.querySelector('.weglot-flag__item.french');
      if (frenchFlag) {
        frenchFlag.style.display = 'none';
      }
    } else {
      const englishFlag = document.querySelector('.weglot-flag__item.english');
      if (englishFlag) {
        englishFlag.style.display = 'none';
      }
    }
  }

  /** Weglot Widget */
  const weglotContainer = document.querySelector('.weglot-parent-container');
  if (weglotContainer) {
    const locationName = window.location.hostname;
    const frenchDomain = 'french.seiufunds';
    const spanishDomain = 'spanish.seiufunds';
    const weglotKey = 'wg_21c53e39a3bc0626424c362fe455d5bd9';
    //If not on french or spanish sub domain, show weglot
    if (locationName.indexOf(frenchDomain) < 0 && locationName.indexOf(spanishDomain) < 0) {
      Weglot.initialize({
        api_key: weglotKey,
        styleOpt: {
          fullname: true,
          withname: true,
          is_dropdown: true,
          classF: 'wg-flags flag-3',
        },
        translateSearch: false,
        hideSwitcher: false,
        switchers: [
          {
            styleOpt: {
              fullname: true,
              withname: true,
              is_dropdown: true,
              classF: 'wg-flags flag-3',
            },
            containerCss: '',
            target: '.weglot-parent-container',
            sibling: null,
          },
        ],
      });
    } else {
      const weglotDisclaimer = document.querySelector('.weglot-disclaimer');
      if (weglotDisclaimer) {
        weglotDisclaimer.style.display = 'none';
      }
    }
  }

  /* Spanish Flag */
  const weglotContainerSpanish = document.querySelector('.weglot-flag--container.spanish');
  if (weglotContainerSpanish) {
    const spanishFlag = document.querySelector('.weglot-flag__item.spanish');
    const englishFlag = document.querySelector('.weglot-flag__item.english');
    const locationHref = window.location.href;
    if (spanishFlag && englishFlag) {
      // If we are on the spanish site, set the english flag url to the english version of the current page and vice versa.
      if (locationName.indexOf('spanish.seiufunds') > -1) {
        const englishLink = locationHref.replace('spanish.', '');
        englishFlag.href = englishLink;
        spanishFlag.style.display = 'none';
        englishFlag.style.display = 'inline-block';
      } else {
        const path = window.location.pathname;
        const spanishLink = 'https://spanish.seiufunds.org' + path;
        spanishFlag.href = spanishLink;
        englishFlag.style.display = 'none';
        spanishFlag.style.display = 'inline-block';
      }
    }
  }
});
